module.exports = {
    AMOUNT: 'Amount',
    PERCENTAGE: 'Percentage',
    BUYONEGET: 'Buy One Get X',
    AMOUNTOFF: 'Amount Off'
}